export const STICKYTIMER_GET_REQUEST = 'STICKYTIMER_GET_REQUEST';
export const STICKYTIMER_GET_SUCCESS = 'STICKYTIMER_GET_SUCCESS';
export const STICKYTIMER_GET_ERROR = 'STICKYTIMER_GET_ERROR';
